type Direction = "top" | "right" | "bottom" | "left";

export function safeAreaPadding(direction: Direction): string;
export function safeAreaPadding(padding: string, direction: Direction): string;
export function safeAreaPadding(arg1: string, arg2?: string): string {
  if (arg2 === undefined) {
    return safeAreaInset(arg1 as Direction);
  }
  return `calc(${arg1} + ${safeAreaInset(arg2 as Direction)})`;
}

export function safeAreaMargin(direction: Direction): string;
export function safeAreaMargin(margin: string, direction: Direction): string;
export function safeAreaMargin(arg1: string, arg2?: string): string {
  if (arg2 === undefined) {
    return safeAreaInset(arg1 as Direction);
  }
  return `calc(${arg1} + ${safeAreaInset(arg2 as Direction)})`;
}

export function safeAreaInset(direction: Direction): string {
  return `max(env(safe-area-inset-${direction}, 0px), var(--safe-area-inset-${direction}, 0px))`;
}
